<template>
  <div id="sidenav-mobile" class="uk-light" uk-offcanvas="overlay: true; mode: push;">
    <div class="uk-offcanvas-bar">

      <div class="ba-create-box uk-padding-small">
        <BitButton>Create New Service</BitButton>
      </div>

      <div class="uk-padding-small">
        <ul class="uk-nav-default uk-nav-parent-icon" uk-nav="multiple: true">
          <li class="uk-nav-header ba-nav-header">
            <span class="uk-margin-small-right" uk-icon="icon: thumbnails; ratio: 1.25"></span>
            Your Services
          </li>
          <router-link :to="{ name: 'VirtualMachines' }" v-slot="{ href, route, navigate, isActive, isExactActive }">
            <li :class="[isActive && 'uk-active', isExactActive && 'uk-active']">
              <a :href="href" @click="navigate" uk-toggle="target: #sidenav-mobile">Virtual Machines</a>
            </li>
          </router-link>

          <li class="uk-nav-divider"></li>

          <li class="uk-nav-header ba-nav-header">
            <span class="uk-margin-small-right" uk-icon="icon: credit-card; ratio: 1.25"></span>
            Billing
          </li>
          <router-link :to="{ name: 'Invoices' }" v-slot="{ href, route, navigate, isActive, isExactActive }">
            <li :class="[isActive && 'uk-active', isExactActive && 'uk-active']">
              <a :href="href" @click="navigate" uk-toggle="target: #sidenav-mobile">Invoices</a>
            </li>
          </router-link>
          <router-link :to="{ name: 'PaymentOptions' }" v-slot="{ href, route, navigate, isActive, isExactActive }">
            <li :class="[isActive && 'uk-active', isExactActive && 'uk-active']">
              <a :href="href" @click="navigate" uk-toggle="target: #sidenav-mobile">Payment Options</a>
            </li>
          </router-link>

          <li class="uk-nav-divider"></li>

          <li class="uk-nav-header ba-nav-header">
            <span class="uk-margin-small-right" uk-icon="icon: lifesaver; ratio: 1.25"></span>
            Support
          </li>
          <router-link :to="{ name: 'Tickets' }" v-slot="{ href, route, navigate, isActive, isExactActive }">
            <li :class="[isActive && 'uk-active', isExactActive && 'uk-active']">
              <a :href="href" @click="navigate" uk-toggle="target: #sidenav-mobile">Tickets</a>
            </li>
          </router-link>

        </ul>
      </div>

      <div class="ba-bottom">
        <ul class="uk-subnav uk-nav-default uk-flex uk-flex-center uk-child-width-1-2" uk-grid>
          <router-link :to="{ name: 'MyAccount' }" v-slot="{ href, route, navigate, isActive, isExactActive }">
            <li :class="[isActive && 'uk-active', isExactActive && 'uk-active']">
              <a :href="href" @click="navigate" uk-toggle="target: #sidenav-mobile">
                <span uk-icon="icon: user; ratio: 1.1" uk-tooltip="title: My Account; position: top"></span>
                My Account
              </a>
            </li>
          </router-link>
          <li class="uk-flex uk-flex-right">
            <a href="#">
              <span uk-icon="icon: sign-out; ratio: 1.1" uk-tooltip="title: Logout; position: top"></span>
              Logout
            </a>
          </li>
        </ul>
      </div>

    </div>
  </div>
</template>

<script>
import BitButton from '@/components/common/button.vue';

export default {
  name: 'SideNavMobile',
  components: {
    BitButton
  }
}
</script>

<style scoped lang="less">
@import "../../assets/less/theme.less";

.uk-offcanvas-bar {
  padding: 0;
  min-height: 1000px;

  .ba-create-box {
    background-color: rgba(0,0,0,0.09);
  }
  .ba-bottom {
    position: fixed;
    width: 230px;
    padding: 20px;
    bottom: 0;
    background-color: rgba(0,0,0,0.09);
    border-top: 1px solid rgba(255,255,255,0.1);
  }
}
.uk-nav-default {
  list-style: none;
  font-size: .875rem;
  li {
    a {
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
}
.ba-nav-header {
  margin-top: 0 !important;

  > a {
    color: rgba(255, 255, 255, 1) !important;
    &:hover {
      color: @ba-gold !important;
    }
  }
  span {
    margin-top: -10px !important;
  }
}
</style>
